module.exports = __webpack_public_path__ + "static/img/back.05830b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/login/back.png
// module id = MIsN
// module chunks = 1